import { login, register, requestPasswordReset, resetPassword   } from '../../api/auth';
import { uploadProfileImage,updateProfile } from '../../api/user';


const state = {
  user: null,
  message: ''
};


const mutations = {
  INITIALIZE_STORE(state) {
    const userDataWithTimestamp = JSON.parse(localStorage.getItem('user'));
    if (userDataWithTimestamp) {
      const currentTime = new Date().getTime();
      const oneDayInMilliseconds = 24 * 60 * 60 * 1000;

      if (currentTime - userDataWithTimestamp.timestamp > oneDayInMilliseconds) {
        // Si le timestamp est plus ancien que 24 heures, déconnectez l'utilisateur
        localStorage.removeItem('user');
        state.user = null;
      } else {
        state.user = userDataWithTimestamp.user;
      }
    }
  },
  SET_USER(state, user) {
    state.user = user;
  },
  SET_MESSAGE(state, message) {
    state.message = message;
  },
  CLEAR_USER(state) {
    state.user = null;  
  },
  SET_USER_PHOTO(state, photoUrl) {
    state.auth.user.data.photo = photoUrl;
  }
};

mutations.INITIALIZE_STORE(state);

const actions = {
  async login({ commit }, credentials) {
    try {
      const response = await login(credentials.email, credentials.password);
      commit('SET_USER', response.data);
      commit('SET_MESSAGE', '');
      const userDataWithTimestamp = {
        user: response.data,
        timestamp: new Date().getTime() 
      };
      localStorage.setItem('user', JSON.stringify(userDataWithTimestamp));
    } catch (error) {
      console.error('An error occurred during login:', error);
      const message = error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Login failed';
      commit('SET_MESSAGE', message);
      throw error; 
    }
  },

  async logout({ commit }) {
    try {
      commit('CLEAR_USER');
  
      localStorage.removeItem('user');
    } catch (error) {
      console.error('An error occurred during logout:', error);
      throw error; 
    }
  },


  async register({ commit }, userData) {
    try {
      const response = await register(
        userData.lastname,
        userData.firstname,
        userData.email,
        userData.phone,
        userData.password
      );
      commit('SET_MESSAGE', response.data.message);
    } catch (error) {
      console.error('An error occurred during registration:', error);
      const message = error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Registration failed';
      commit('SET_MESSAGE', message);
      throw new Error(message); // Propager l'erreur pour la gestion dans le composant
    }
  },   

  async requestPasswordReset({ commit }, payload) {
    try {
      const response = await requestPasswordReset(payload.email);
      commit('SET_MESSAGE', response.data.message);
    } catch (error) {
      console.error('An error occurred during password reset request:', error);
      commit('SET_MESSAGE', 'Password reset request failed');
    }
  },
  

  async uploadProfileImage({ commit }, payload) {
    try {
      const response = await uploadProfileImage(payload.userId, payload.file);
      commit('SET_USER', response.data);
      commit('SET_MESSAGE', response.data.message || 'Image upload successful');
      const userDataWithTimestamp = {
        user: response.data,
        timestamp: new Date().getTime() 
      };
      localStorage.setItem('user', JSON.stringify(userDataWithTimestamp));
    } catch (error) {
      console.error('An error occurred during image upload:', error);
      commit('SET_MESSAGE', 'Image upload failed');
    }
  },

  async updateProfile({ commit }, payload) {
    try {
      const response = await updateProfile(payload);
      commit('SET_USER', response.data);
      commit('SET_MESSAGE', response.data.message);
      const userDataWithTimestamp = {
        user: response.data,
        timestamp: new Date().getTime() 
      };
      localStorage.setItem('user', JSON.stringify(userDataWithTimestamp));
    } catch (error) {
      console.error('An error occurred during profile update:', error);
      commit('SET_MESSAGE', 'Profile update failed');
    }
  },


  async resetPassword({ commit }, payload) {
    try {
      const response = await resetPassword(
        payload.code,
        payload.password,
        payload.password2,
        payload.id
      );
      commit('SET_MESSAGE', response.data.message);
    } catch (error) {
      console.error('An error occurred during password reset:', error);
      commit('SET_MESSAGE', 'Password reset failed');
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
